export const SUPPORT_UNREAD_CHANGED = 'support-unread-changed';

export const notifySupportUnreadChanged = (totalUnread) => {
    if (typeof window === 'undefined') {
        return;
    }
    const detail = {};
    if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
        detail.totalUnread = Math.max(0, Math.floor(totalUnread));
    }
    window.dispatchEvent(new CustomEvent(SUPPORT_UNREAD_CHANGED, { detail }));
};

export const isTicketUnseenForViewer = (ticket, loggedInUser) => {
    if (!ticket || !loggedInUser) {
        return false;
    }
    if (loggedInUser.role === 'admin') {
        return ticket.admin_seen !== true;
    }
    return ticket.user_seen !== true;
};
